// extracted by mini-css-extract-plugin
export var blue = "_2j-g";
export var brand = "_2j-c";
export var darkGrey = "_2j-f";
export var disabled = "_2j-6";
export var disabledSubtle = "_2j-7";
export var error = "_2j-8";
export var green = "_2j-h";
export var grey = "_2j-e";
export var icon = "_2j-0";
export var inherit = "_2j-b";
export var lightGrey = "_2j-d";
export var orange = "_2j-j";
export var pink = "_2j-l";
export var primary = "_2j-1";
export var purple = "_2j-m";
export var quaternary = "_2j-4";
export var quinary = "_2j-5";
export var red = "_2j-k";
export var secondary = "_2j-2";
export var success = "_2j-a";
export var tertiary = "_2j-3";
export var warning = "_2j-9";
export var white = "_2j-n";
export var yellow = "_2j-i";